/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _EventsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventBySlug>}  */
  getEventBySlug: createAPIHandler(
    ([slug, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(slug)}/slug`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventName>}  */
  getEventName: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(eventId)}/name`,
      { method: "GET", query }
    ]
  ),
};
export { _EventsAPI as EventsAPI };
const _SettingsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/settings.js").getSettings>}  */
  getSettings: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/settings`,
      { method: "GET", query }
    ]
  ),
};
export { _SettingsAPI as SettingsAPI };
const _ShareAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/share.js").sharePhoto>}  */
  sharePhoto: createAPIHandler(
    ([eventId, photoId, format, query = undefined]) => [
      `/n/api/public/event/${encodeURIComponent(eventId)}/share/photo/${encodeURIComponent(photoId)}/${encodeURIComponent(format)}`,
      { method: "GET", query }
    ]
  ),
};
export { _ShareAPI as ShareAPI };
const _StatsAPI = {
  /** @type {DownloadAPI<import("../../../../backend/api/public/stats.js").exportOrganizationStats>}  */
  exportOrganizationStats: async function(query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/stats/organization/export`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `export`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
};
export { _StatsAPI as StatsAPI };
const _StepperSupportAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/stepper-support.js").reportStepperSupport>}  */
  reportStepperSupport: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/report-stepper-support`,
      { method: "POST", body, query }
    ]
  ),
};
export { _StepperSupportAPI as StepperSupportAPI };
const _TimeAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/time.js").getTime>}  */
  getTime: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/getTime`,
      { method: "GET", query }
    ]
  ),
};
export { _TimeAPI as TimeAPI };
const _WallAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").getEventPhotos>}  */
  getEventPhotos: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/event/${encodeURIComponent(eventId)}/photos`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").getEventPhotosRss>}  */
  getEventPhotosRss: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/event/${encodeURIComponent(eventId)}/photos.rss`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").getEvent>}  */
  getEvent: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/event/${encodeURIComponent(eventId)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").getOrganization>}  */
  getOrganization: createAPIHandler(
    ([idOrganization, query = undefined]) => [
      `/n/api/public/organization/${encodeURIComponent(idOrganization)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").getCategory>}  */
  getCategory: createAPIHandler(
    ([idCategory, query = undefined]) => [
      `/n/api/public/category/${encodeURIComponent(idCategory)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/wall.js").likePhoto>}  */
  likePhoto: createAPIHandler(
    ([photo_id, body = {}, query = undefined]) => [
      `/n/api/public/like/${encodeURIComponent(photo_id)}`,
      { method: "PATCH", body, query }
    ]
  ),
};
export { _WallAPI as WallAPI };
